// extracted by mini-css-extract-plugin
export default {"top-2-box-item":"Top2BoxItem_top-2-box-item__Uv+QX","top-2-box-item-label":"Top2BoxItem_top-2-box-item-label__kCeOH"};